"use client";

import React from "react";

import { ModalHeaderBase } from "./ModalHeaderBase";
import { useModalHeaderContext } from "./ModalHeaderContext";

export const ModalInlineHeader: React.FC<
  React.PropsWithChildren<{ className?: string }>
> = ({ children, className }) => {
  const { inlineRef } = useModalHeaderContext();

  return (
    <ModalHeaderBase aria-hidden ref={inlineRef} className={className}>
      {children}
    </ModalHeaderBase>
  );
};
